// Components==============
import { AnimateSharedLayout, motion } from 'framer-motion';
import { useTranslate } from 'hooks/useTranslate';
import React, { useRef } from 'react';
import Dropdown from '../Dropdown/Dropdown';
import './BigToggle.module.scss';
// =================

type ArrayTwoOrMore<T> = {
  0: T;
  1: T;
} & Array<T>;

const transition = {
  type: 'tween',
  duration: 0.3,
};

export default function BigToggle({
  selected,
  setSelected,
  values,
  white,
  query,
}: {
  selected: any;
  setSelected: React.Dispatch<React.SetStateAction<any>>;
  values: ArrayTwoOrMore<string>;
  white?: boolean;
  query?: boolean;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const translate = useTranslate();

  if (query !== undefined && !query)
    return (
      <Dropdown
        selectedItem={selected}
        setSelectedItem={setSelected}
        initialText={selected}
        initialOptions={values.map((v) => v)}
        translateOptions
      />
    );

  return (
    <div styleName={`big-toggle ${white ? 'white' : ''}`} ref={ref}>
      <AnimateSharedLayout>
        {values.map((value, i) => (
          <div
            onClick={() => setSelected(value)}
            styleName={` text ${selected === value ? 'active' : ''}`}
            key={i}
          >
            {selected === value && (
              <motion.div
                layoutId="slider"
                styleName="slider"
                initial={false}
                transition={transition}
              />
            )}
            <p>{translate(value)}</p>
          </div>
        ))}
      </AnimateSharedLayout>
    </div>
  );
}
